import { PoleEmploiCity } from '@models/pole-emploi/city';

export interface CejCity {
  id?: string;
  name: string;
  zipCode: string;
  inseeCode: string;
  geoPoint: {
    lat: number;
    lon: number;
  };
}

export function toCejCity(city: PoleEmploiCity): CejCity {
  return {
    id: city.objectID,
    name: city.libelle,
    zipCode: city.codePostal,
    inseeCode: city.code,
    geoPoint: {
      lat: city.geoPoint.lat,
      lon: city.geoPoint.lon,
    },
  };
}
